import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import handleAsyncThunk from '../handleAsyncThunk';
import supplierApi from "../../service/supplierApi";
import { showSuccessSnackbar, showErrorSnackbar } from "./snackbarSlice";

export const createNewSupplier = createAsyncThunk("supplier/createNewSupplier", async (data, { rejectWithValue , dispatch}) => {
    try {
        const response = await supplierApi.addSupplier(data);
        console.log(response);
        if (response.data.status === 201) {
            dispatch(showSuccessSnackbar({ title: "Supplier created successfully" }));
            return response?.data;
        } else {
            
            dispatch(showErrorSnackbar({ title: response?.message || "Something went wrong" }));
            return rejectWithValue(response?.message);
        }
    } catch (error) {
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message);
        
    }
});

export const getSuppliers = createAsyncThunk("supplier/getSuppliers", async (data, { rejectWithValue, dispatch }) => {
    try {
         const response = await supplierApi.getSuppliers(data);
        if (response.status === 200) {
            // dispatch(showSuccessSnackbar({ title: "Contacts fetched successfully" }));
            return response?.data;
        } else {
            dispatch(showErrorSnackbar({ title: response?.message || "Something went wrong" }));
            return rejectWithValue(response?.message);
        }
    } catch (error) {
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message);
        
    }
});    

export const getSupplierById = createAsyncThunk("supplier/getSupplierById", async (data, { rejectWithValue, dispatch }) => {
    try {
        
         const response = await supplierApi.getSupplierById(data);
        if (response.status === 200) {
            // dispatch(showSuccessSnackbar({ title: "Contacts fetched successfully" }));
            return response?.data;
        } else {
            dispatch(showErrorSnackbar({ title: response?.message || "Something went wrong" }));
            return rejectWithValue(response?.message);
        }
    } catch (error) {
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message);
        
    }
});
export const getSupplierAddress = createAsyncThunk("supplier/getSupplierAddress", async (data, { rejectWithValue, dispatch }) => {
    try {
        
         const response = await supplierApi.getSupplierAddress(data);
        if (response.status === 200) {
            // dispatch(showSuccessSnackbar({ title: "Contacts fetched successfully" }));
            return response?.data;
        } else {
            dispatch(showErrorSnackbar({ title: response?.message || "Something went wrong" }));
            return rejectWithValue(response?.message);
        }
    } catch (error) {
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message);
        
    }
});

export const updateSupplier = createAsyncThunk("supplier/updateSupplier", async (data, { rejectWithValue, dispatch }) => {
    try {
        
         const response = await supplierApi.updateSupplier(data);
         console.log(response);
        if (response.status === 200) {
            // dispatch(showSuccessSnackbar({ title: "Contacts fetched successfully" }));
            return response?.data;
        } else {
            dispatch(showErrorSnackbar({ title: response?.message || "Something went wrong" }));
            return rejectWithValue(response?.message);
        }
    } catch (error) {
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message);
        
    }
});

export const deleteSupplier = createAsyncThunk("supplier/deleteSupplier", async (data, { rejectWithValue, dispatch }) => {
    try {
        
         const response = await supplierApi.deleteSupplier(data);
        if (response.status === 200 || response.status === 204) {
            dispatch(showSuccessSnackbar({ title: "Supplier deleted successfully" }));
            return response?.data;
        } else {
            dispatch(showErrorSnackbar({ title: response?.message || "Something went wrong" }));
            return rejectWithValue(response?.message);
        }
    } catch (error) {
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message);
        
    }
})


const supplierSlice = createSlice({
    name: "supplier",
    initialState: {
        data: null,
        status: null,
        error: null,
        isLoading: false,
        suppliers: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        handleAsyncThunk(builder, createNewSupplier, "data", "error", "supplierLoading");
        handleAsyncThunk(builder, getSuppliers, "suppliers", "error", "suppliersListLoading");
        handleAsyncThunk(builder, getSupplierById, "supplierById", "error", "supplierByIdLoading");
        handleAsyncThunk(builder, deleteSupplier, "data", "error", "deleteSupplierLoading");
        handleAsyncThunk(builder, updateSupplier, "data", "error", "updateSupplierLoading");
        handleAsyncThunk(builder, getSupplierAddress, "supplierAddress", "error", "supplierAddressLoading");
        // handleAsyncThunk(builder, getContactById, "contactById", "error", "contactByIdLoading");
        // handleAsyncThunk(builder, deleteContact, "data", "error", "deleteContactLoading");
        // handleAsyncThunk(builder, updateContact, "data", "error", "updateContactLoading");
    },
});

export default supplierSlice.reducer;